'use strict';
// Owner navigation words are derived from the visible card list. Public sharing
// uses lib/card-address instead: its generation-bound addresses cannot move to
// a different card when this list changes.

const { isReserved } = require('./reserved-paths');

const EVERYTHING = 'everything';

/** A card's word, from its name: "Data Scientist, Pricing" → data-scientist-pricing. */
function wordOf(name) {
  return String(name || '').normalize('NFKD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'card';
}

/** Every card's word: card_id → word. */
function cardWords(cards) {
  const words = new Map();
  const taken = new Set();
  for (const c of [...cards].sort((a, b) => (a.card_id < b.card_id ? -1 : 1))) {
    const own = wordOf(c.name);
    const base = isReserved(own) || own === EVERYTHING ? `${own}-card` : own;
    let word = base;
    for (let n = 2; taken.has(word); n += 1) word = `${base}-${n}`;
    taken.add(word);
    words.set(c.card_id, word);
  }
  return words;
}

/** A KEPT CARD'S FILE NAME (owner call 2026-10-28, "more substantive and professional"): Caliber, its holder and its
 *  name, as one word: { holder: "Maya Ellison", name: "Senior Data Scientist" } → caliber-card-maya-ellison-senior-data-scientist.
 *  The zip, its page, its print and its record all go by it. */
function fileWordOf({ holder, name }) {
  return ['caliber-card', holder, name].map((part) => (part ? wordOf(part) : '')).filter(Boolean).join('-');
}

module.exports = { EVERYTHING, wordOf, cardWords, fileWordOf };
